import { render } from "./EllipseOne.svg?vue&type=template&id=5fb142a4"
const script = {}
script.render = render

export default script